export default __webpack_public_path__ + "static/media/full_class_field.b6f4f861.jpg";